import type {ExtraDeliveryItem} from 'store/slices/extra-delivery/types';

import {dateToReadableDate} from '@date-picker';
import {Loading} from '@ds/components';
import InfiniteScroll from 'react-infinite-scroll-component';
import {useNavigate} from 'react-router-dom';

import {EXTRA_DELIVERY_ROUTES} from '../../../constants';
import ExtraDeliveryHistoryItem from './components/ExtraDeliveryHistoryItem/ExtraDeliveryHistoryItem';

type ExtraDeliveryHistoryListProps = {
  items: ExtraDeliveryItem[];
  totalItems: number;
  onLoadMore: () => void;
};

const ExtraDeliveryHistoryList: React.FC<ExtraDeliveryHistoryListProps> = ({
  items,
  totalItems,
  onLoadMore
}) => {
  const navigate = useNavigate();

  return (
    <InfiniteScroll
      next={onLoadMore}
      dataLength={items.length}
      scrollableTarget="extra-delivery-history-list"
      hasMore={items.length < totalItems}
      loader={
        <div className="flex h-10 justify-center">
          <Loading size="medium" color="primary" />
        </div>
      }
      scrollThreshold={0.6}
    >
      {items.map((item, index) => (
        <ExtraDeliveryHistoryItem
          key={item.id}
          subtitle={dateToReadableDate({
            date: item.start_date,
            day: true,
            month: true
          })}
          state={item.state}
          noBorder={index === items.length - 1}
          onClick={() =>
            navigate(EXTRA_DELIVERY_ROUTES.details.replace(':extraDeliveryId', String(item.id)))
          }
        />
      ))}
    </InfiniteScroll>
  );
};

export default ExtraDeliveryHistoryList;
